// components/ui/Button.tsx
import React from 'react';
import { ButtonProps } from '../../types/index';

const Button: React.FC<ButtonProps> = ({
                                         onClick,
                                         type = 'button',
                                         variant = 'primary',
                                         className = '',
                                         children,
                                         href,
                                         newTab = false,
                                         disabled = false,
                                       }) => {
  const baseStyles = 'px-6 py-3 rounded-lg font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-opacity-75 transition-all duration-150 ease-in-out';
  const variantStyles = {
    primary: disabled
      ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
      : 'bg-lime-600 hover:bg-lime-700 text-white focus:ring-lime-500',
    secondary: disabled
      ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
      : 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500',
    outline: disabled
      ? 'bg-gray-100 text-gray-400 border-2 border-gray-300 cursor-not-allowed'
      : 'bg-transparent hover:bg-lime-50 text-lime-600 border-2 border-lime-600 focus:ring-lime-500',
  };

  const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className}`;

  if (href) {
    return (
      <a
        href={href}
        className={combinedClassName}
        target={newTab ? '_blank' : '_self'}
        rel={newTab ? 'noopener noreferrer' : undefined}
      >
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={combinedClassName}>
      {children}
    </button>
  );
};

export default Button;
